import { InstructorsPendingLetterProvider } from '@features/instructors/contexts/pending-letter/InstructorsPendingLetterProvider';
import * as React from 'react';

import type { InstructorApprovalLetterPanelProps } from './InstructorApprovalLetterPanel.types';

import { ApprovalLetterPanelShell } from './components/approval-letter-panel-shell/ApprovalLetterPanelShell';

const InstructorApprovalLetterPanel = React.memo(
  ({
    onClose,
  }: Readonly<InstructorApprovalLetterPanelProps>): React.ReactElement => (
    <InstructorsPendingLetterProvider>
      <ApprovalLetterPanelShell onClose={onClose} />
    </InstructorsPendingLetterProvider>
  )
);

InstructorApprovalLetterPanel.displayName = 'InstructorApprovalLetterPanel';
export { InstructorApprovalLetterPanel };
